export interface BankDetails {
  underwriterCode: string;
  bankName: string;
  routingNumber: string;
  accountNumber: string;
  accountName: string;
  address: string;
}

// Consolidated configuration with all bank details per underwriter
// Based on Anita Johnson's data from ANS-11271 comment 508629
export const underwriterBankDetails: Record<string, BankDetails> = {
  FATIC: {
    underwriterCode: 'FATICO',
    bankName: 'JPMorgan Chase',
    routingNumber: '021000021',
    accountNumber: '0699289310',
    accountName: 'FIRST AMERICAN TITLE INSURANCE CO',
    address: 'JPMorgan Chase New York, NY 10017',
  },
  FATGC: {
    underwriterCode: 'FATGC',
    bankName: 'JPMorgan Chase',
    routingNumber: '021000021',
    accountNumber: '657580663',
    accountName: 'FIRST AMERICAN TITLE GUARANTY COMPANY',
    address: 'JPMorgan Chase New York, NY 10017',
  },
  'FATIC-LA': {
    underwriterCode: 'FALA',
    bankName: 'JPMorgan Chase',
    routingNumber: '021000021',
    accountNumber: '790007629',
    accountName: 'First American Title Insurance Company of Louisiana',
    address: 'JPMorgan Chase New York, NY 10017',
  },
  FAST: {
    underwriterCode: 'FAST',
    bankName: 'First American Trust, FSB',
    routingNumber: '122241255',
    accountNumber: '1010010000', // Service Order invoices - separate account from Remittance
    accountName: 'First American Title Insurance Company',
    address: 'First American Trust, FSB',
  },
};

// Helper function to get bank details with fallback
export const getBankDetails = (underwriter: string | undefined): BankDetails | null => {
  if (!underwriter) return null;
  return underwriterBankDetails[underwriter] || null;
};

// Legacy exports - kept for backward compatibility
export const underwriter_acNum: Record<string, string> = Object.keys(underwriterBankDetails).reduce(
  (acc, key) => ({
    ...acc,
    [key]: underwriterBankDetails[key].accountNumber,
  }),
  {},
);

export const underwriter_code: Record<string, string> = Object.keys(underwriterBankDetails).reduce(
  (acc, key) => ({
    ...acc,
    [key]: underwriterBankDetails[key].underwriterCode,
  }),
  {},
);

export const validateDataFields = ['wireNumber', 'checkNumber', 'email', 'memo', 'ePayId'];

export const paymentOptions = [
  { label: 'ePay', value: 'ePay', dataTestId: 'PaySumOptionePay' },
  { label: 'Check', value: 'Check', dataTestId: 'PaySumOptionCheck' },
  { label: 'Wire', value: 'Wire', dataTestId: 'PaySumOptionWire' },
];
